var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0626 15C14.0626 15.5178 14.4835 15.9375 15.0027 15.9375C15.5219 15.9375 15.9429 15.5178 15.9429 15C15.9429 14.4822 15.5219 14.0625 15.0027 14.0625C14.4835 14.0625 14.0626 14.4822 14.0626 15Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0626 21.5625C14.0626 22.0803 14.4835 22.5 15.0027 22.5C15.5219 22.5 15.9429 22.0803 15.9429 21.5625C15.9429 21.0447 15.5219 20.625 15.0027 20.625C14.4835 20.625 14.0626 21.0447 14.0626 21.5625Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0626 8.4375C14.0626 8.95526 14.4835 9.375 15.0027 9.375C15.5219 9.375 15.9429 8.95526 15.9429 8.4375C15.9429 7.91973 15.5219 7.5 15.0027 7.5C14.4835 7.5 14.0626 7.91973 14.0626 8.4375Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.87421f172be64826376019de7d6857d8.svg";
export { ForwardRef as ReactComponent };